export default __webpack_public_path__ + "static/media/logo.170729b0.png";